import ReactMapGlMap from './reactmapgl';

export default {
  reactmapgl: ReactMapGlMap
};
